import { filterWithCustomTargeting } from "@/helpers/builder/filterWithCustomTargeting";
import { getBlocksToRender } from "@/helpers/builder/getBlocksToRender";
import {
  BuilderAttributes,
  BuilderProps,
  UserAttributes,
  Variant,
} from "@/types";
import { Blocks } from "@builder.io/sdk-react";
import { FC } from "react";

type PersonalizationContainerProps = {
  attributes?: BuilderAttributes;
  previewingIndex?: number | null;
  variants?: Variant[];
  targeting: UserAttributes | null;
} & BuilderProps;

export const PersonalizationContainer: FC<PersonalizationContainerProps> = (
  props,
) => {
  const filteredVariants = props.variants?.filter(
    ({ query, startDate, endDate }) =>
      filterWithCustomTargeting(
        props.targeting ?? {},
        query,
        startDate,
        endDate,
      ),
  );
  const blocksToRender = getBlocksToRender({
    variants: props.variants,
    previewingIndex: props.previewingIndex,
    fallbackBlocks: props.builderBlock.children,
    filteredVariants,
  });

  return (
    <div {...props.attributes}>
      <Blocks
        blocks={blocksToRender.blocks}
        path={blocksToRender.path}
        context={props.builderContext}
        linkComponent={props.builderLinkComponent}
        registeredComponents={props.builderComponents}
        parent={props.builderBlock?.id}
      />
    </div>
  );
};
